import Accordian from './Accordian';
export default Accordian;
